import React from 'react';
import ReportContent from "./content/report-content.jsx";
import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import ReportDetailedContent from "./content/report-detailed-content.jsx";
const Content = ({reportData, data, entity, title, printComponentRef, setLoading, searchDetails, tableColumns}) => {
    return (
        <>
            {
                reportData && data > 0 && (
                    <PrintTemplate entity={entity} title={title} ref={printComponentRef} setIsPrinting={setLoading}>
                        <div id="filters-print" className={'transform !-translate-y-[8.5px]'}></div>
                        <div className="print:border-b print:border-gray-200 print:mb-6 print:w-full"/>

                        <div className={"w-full print:mt-[0]"}>
                            { searchDetails ? <ReportDetailedContent data={reportData}/> : <ReportContent data={reportData} tableColumns={tableColumns}/>}
                        </div>
                    </PrintTemplate>
                )
            }
        </>
    );
};

export default Content;